import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import * as actionTypes from "../../redux/actionTypes";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import {
  SplitPane,
} from "react-collapse-pane";
import editcss from "../../myfin_v2/css/editTranslation.module.css";
import { Submit } from "../../Components/Button";
import Filter from "../../Components/Filter";
import BasicTable from "../../Components/Table/BasicTable";
import DeleteSelected from "../../Components/deleteSelected/DeleteSelected";
import TemplateTabs from "../../Components/templateTabs/TemplateTabs";
import DeletedFile from "../../Components/deletedItems/DeletedFile";
import PopulateFs from "../../Components/populateFs/PopulateFs";
import ExpandLedger from "../../Components/expandLedger/ExpandLedger";
import AddLedger from "../../Components/addLedger/AddLedger";
import AddGrouping from "../../Components/AddGrouping/AddGrouping";
import Confirmation from "../../Components/confirmationMenu/confirmationMenu";
import ShareScreen from "../../Components/shareScreen/ShareScreen";
import SwitchMode from "../../Components/switchMode/SwitchMode";
import "./template.css";
import Typography from "@mui/material/Typography";
// import Modal from "@mui/material/Modal";
import SuccessPopup from "../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../myfin_v2/elements/ErrorPopup";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import { Alert, Snackbar, Checkbox } from "@mui/material";
import { AccessProjectContext } from "../../helper/DarkModeContext";
import DeleteDuplicate from "../../Components/deletedItems/DeleteDuplicate";
import DeletedItemsPage from "./DeletedItemsPage";
import { red } from "@mui/material/colors";
import AssignValuesData from "../setupProject/AssignValuesData";
import {
  deleteConventionalLineItems,
  getAllProjects,
  getProfile,
} from "../../services/api/apiHandler";
import {
  deleteLineItems,
  fetchConventionalMode,
} from "../../redux/actions/TemplateTabs/actionCM";
import { motion } from "framer-motion";
import AddNoteGroup from "../../Components/AddGrouping/AddNotes";
import { toggleCheckYearly } from "../../redux/actions/TemplateTabs/actionDragSelector";
import { useLocation } from "react-router";
import { getAllWorkspace, retranslateFS, exportTranslateFS, getMappingDetails, fetchInvestmentRegisters } from "../../WorkSpace/Components/ApiServices/apiHandler";
import CommonProgressBar from "../../Components/Common/ProgressBar";
import { fetchTTBSData } from "../../redux/actions/TemplateTabs/actionBS";
import { fetchTTPNLData } from "../../redux/actions/TemplateTabs/actionPNL";
import commoncss from "../../myfin_v2/css/common.module.css"
import Sidebar from "../../myfin_v2/elements/Sidebar"
import buttoncss from "../../myfin_v2/css/button.module.css";
import bookclosuretbcss from "../../myfin_v2/css/bookclosuretb.module.css";
import { ReactComponent as FilterIcon } from "../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as LeftIcon } from "../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as SearchIcon } from "../../myfin_v2/assets/icons/searchPri.svg";
import { ReactComponent as DeleteIcon } from "../../myfin_v2/assets/icons/delete_icon_primary.svg";
import MultipleFiles from "../../myfin_v2/assets/icons/MultipleFiles.png";
import MultipleSheets from "../../myfin_v2/assets/icons/MultipleSheets.png";
import { ReactComponent as RecycleBinIcon } from "../../myfin_v2/assets/icons/recycleBin.svg";
import { ReactComponent as EditIcon } from "../../myfin_v2/assets/icons/editPri.svg";
import Dropdown from "../../myfin_v2/elements/Dropdown";
import ToggleButton from "../../myfin_v2/elements/ToggleButton";
import { Button } from "../../myfin_v2/elements/Button";
import Modal from "../../../src/myfin_v2/elements/Modal";
import modalcss from "../../../src/myfin_v2/css/modal.module.css";
import { ReactComponent as DeleteIconWhite } from "../../myfin_v2/assets/icons/delete.svg";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as ExportIcon } from "../../myfin_v2/assets/icons/export.svg";
import { ReactComponent as DropdownIcon } from "../../myfin_v2/assets/icons/down-arrow.svg";
import { ReactComponent as CalendarIcon } from "../../myfin_v2/assets/icons/calender.svg";

import Checkmark from "../../myfin_v2/assets/icons/Check(circle).png";

const NewTemplate = () => {
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorData, setErrorData] = useState(null);
  const user = JSON.parse(localStorage.getItem('user'));
  const ws_id = localStorage.getItem('ws_id');
  
  let history = useHistory();
  const dispatch = useDispatch();
  const tableData = useSelector(
    (initialState) => initialState.reducer.tableData
  );
  const filterData = useSelector((initialState) => initialState.reducer.filter);
  const grouping = useSelector((initialState) => initialState.reducer.grouping);
  const groupData = useSelector((state) => state.TTGroupingReducer);
  const conventionMode = useSelector((state) => state.ConventionModeReducer);
  const { multiSelectedRows, checkYearly } = useSelector(
    (state) => state.selectedDragReducer
  );
  const [openCurrency, setOpenCurrency] = useState(false);
  const { loading, error_message, response } = conventionMode;
  const [filterQuery, setFilterQuery] = useState([]);
  const [filterRow, setFilterRow] = useState([]);
  const [totalRow, setTotalRow] = useState([]);
  const [totalFilter, setTotalFilter] = useState([]);
  const [filterShow, setFilterShow] = useState(false);
  const [filterEnable, setFilterEnable] = useState(false);
  const [object, setObject] = useState({});
  const [select, setSelect] = useState({});
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deletedMenu, setDeleteMenu] = useState(false);
  const [populateFs, setPopulateFs] = useState(false);
  const [otherGrouping, setOtherGrouping] = useState(grouping);
  const [addLedger, setAddLedger] = useState(false);
  const [expandLedger, setExpandLedger] = useState(false);
  const [addLedgerAbove, setAddLedgerAbove] = useState(false);
  const [addLedgerBelow, setAddLedgerBelow] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [addGrouping, setAddGrouping] = useState(false);
  const [addNoteGrp, setAddNoteGrp] = useState(false);
  const [confirmationMenu, setConfirmationMenu] = useState();
  const [showSwitchMode, setSwitchMode] = useState(false);
  const [render, setRender] = useState("");
  const [editTranslation, setEditTranslation] = useState(false);
  const [confirmfilClose, SetConfirmFilClose] = useState(false);
  const [newSg, SetNewSg] = useState();
  const [hideItems, SetHideItems] = useState(false);
  const [shareScreen, SetShareScreen] = useState(false);
  const [showDeletedItems, setShowDeletedItems] = useState(false);
  //   const [loading, setLoading] = useState(false);
  const R_tb_id = useSelector((initialState) => initialState.reducer.tb_id);
  const LOCAL_tb_id = localStorage.getItem("tb_id");
  let tb_id = R_tb_id ? R_tb_id : LOCAL_tb_id;

  const [hiddenFilter, setHiddenFilter] = useState([]);
  const tableRowRefs = useRef({});

 const handleNoteSelect = (label) => {
  if (!label) return;

  const conventionalData = conventionMode?.response?.data?.line_items || [];
  const normalizedLabel = label.toLowerCase().trim();

  // Find all rows whose note_grp matches the selected label
  const matchedRows = conventionalData.filter((row) => {
    const noteGrp =
      row?.map_data?.cy_map?.note_grp ||
      row?.map_data?.py_map?.note_grp ||
      row?.note_grp;
    return noteGrp && noteGrp.toLowerCase().trim() === normalizedLabel;
  });

  if (!matchedRows.length) return;

  let targetEl = null;
  for (const row of matchedRows) {
    const el = tableRowRefs.current[row.ledger_name];
    if (el) {
      targetEl = el;
      break;
    }
  }

  if (!targetEl) return;

  targetEl.scrollIntoView({ behavior: "smooth", block: "center" });

  setTimeout(() => {
    targetEl.classList.add("note-fade-row");
    targetEl.addEventListener(
      "animationend",
      () => targetEl.classList.remove("note-fade-row"),
      { once: true }
    );
  }, 300);
};

  const [updateRows, setUpdateRows] = useState(false);
  const [tb_upload, uploadTb] = useState(false);
  const [deleteRow, setDeleteRow] = useState(false);
  const { access, setAccess } = useContext(AccessProjectContext);
  const [rowData, setRowData] = useState({});
  const [countdata, getDataCount] = useState("");
  const [updateTabs, setUpdateTabs] = useState(false);
  const [duplicateItems, setDuplicateItems] = useState([]);
  const [openDuplicateModal, setDuplicateModal] = useState(false);
  const [showAssignValues, setAssignValues] = useState(false);
  const [info, setinfo] = useState([]);
  const [index, setIndex] = useState("");
  const [headerdata, setHeaders] = useState([]);
  const [tempID, setTempID] = useState("");
  const [type, setType] = useState("");
  const [allProject, setAllProject] = useState([]);
  const [allWorkspace, setAllWorkspace] = useState([]);
  const [deleteItemsModel, setDeleteItemsModal] = useState(false);
  const [translationData, setTranslationData] = useState({
  reportingCurrency: "",
  currentYearOpeningRate: "",
  currentYearClosingRate: "",
  currentYearAverageRate: "",
  previousYearOpeningRate: "",
  previousYearClosingRate: "",
  previousYearAverageRate: "",
});
  const [functionalCurrency, setFunctionalCurrency] = useState("");
  const [currentFinancialYear, setCurrentFinancialYear] = useState("");
  const [previousFinancialYear, setPreviousFinancialYear] = useState("");
  const [hasTranslatedFS, setHasTranslatedFS] = useState(false);
  const [allInvestmentRegisters, setAllInvestmentRegisters] = useState([]);
  const [investmentRegister, setInvestmentRegister] = useState(null);

  useEffect(() => {
    const getInvestmentRegisters = async () => {
      try {
        const res = await fetchInvestmentRegisters();
        if (res?.data?.success) {
          const formattedInvestments = res.data.investmentList.map((inv) => ({
            label: inv.name,
            value: inv._id
          }));
          setAllInvestmentRegisters(formattedInvestments);
        }
      } catch (error) {
        console.log("Error fetching investments", error);
      }
    };
    getInvestmentRegisters();
  }, []);

const handleSelectCurrency = (value) => {
  setTranslationData((prev) => ({
    ...prev,
    reportingCurrency: value,
  }));

  setOpenCurrency(false);
};

const handleTranslationChange = (e) => {
  const { name, value } = e.target;

  setTranslationData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleExportTranslation = async () => {
  try {
    const project_id = localStorage.getItem("project_id");

    const response = await exportTranslateFS(project_id);

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Translation_Workings.xlsx");

    document.body.appendChild(link);
    link.click();
    link.remove();

    toast.success("File downloaded successfully");
  } catch (error) {
    toast.error("Export failed");
  }
};

const handleSaveTranslation = async () => {
  try {
    const body = {
      reportingCurrency: translationData.reportingCurrency,
      investmentID: investmentRegister?.value,
      translateFS: {
        currentYearOpeningRate: Number(translationData.currentYearOpeningRate),
        currentYearClosingRate: Number(translationData.currentYearClosingRate),
        currentYearAverageRate: Number(translationData.currentYearAverageRate),
        previousYearOpeningRate: Number(translationData.previousYearOpeningRate),
        previousYearClosingRate: Number(translationData.previousYearClosingRate),
        previousYearAverageRate: Number(translationData.previousYearAverageRate),
      },
    };

    await retranslateFS(project_id, body);

    setSuccessMessage("Translation updated successfully");
    setShowSuccessPopup(true);
  } catch (error) {
    setErrorData({
      title: "Error",
      message: "Something went wrong"
    });
  }
};

const fetchMappingDetails = async () => {
  try {
    const projectID = localStorage.getItem("project_id");

    const res = await getMappingDetails(projectID);

    if (res?.data?.success) {
      const data = res.data;

      if (data.translateFS && Object.keys(data.translateFS).length > 0 || data.reportingCurrency) {
        setHasTranslatedFS(true);
      } else {
        setHasTranslatedFS(false);
      }

      setFunctionalCurrency(data.currency || "");

      setTranslationData({
        reportingCurrency: data.reportingCurrency || "",
        currentYearOpeningRate: data.translateFS?.currentYearOpeningRate || "",
        currentYearClosingRate: data.translateFS?.currentYearClosingRate || "",
        currentYearAverageRate: data.translateFS?.currentYearAverageRate || "",
        previousYearOpeningRate: data.translateFS?.previousYearOpeningRate || "",
        previousYearClosingRate: data.translateFS?.previousYearClosingRate || "",
        previousYearAverageRate: data.translateFS?.previousYearAverageRate || "",
      });

      setCurrentFinancialYear(data.currentYear || "");
      setPreviousFinancialYear(data.previousYear || "");
    }
  } catch (error) {
    console.log("Mapping API error:", error);
  }
};

  let init = {
    LedgerCode: "",
    currentBalance: "",
    ledgerName: "",
    previousBalance: "",
    tbAmount: "",
  };
  const [Name, setName] = useState(init);

  const project_id = localStorage.getItem("project_id");
  const auth = localStorage.getItem("auth_token");
  let headers = {
    "x-auth-token": auth,
  }; 

  let vertical = "bottom";
  let horizontal = "right";

  const projectId = useParams();

  useEffect(() => {
    (async () => {
      await fetchUserProfile();
      await fetchConvential();
      // await fetchGroupData();
    })();
  }, []);

  useEffect(() => {
    const pathname = window.location.pathname;
    const pathParts = pathname.split('/');
    if (pathParts.includes('templateV2')) {
      localStorage.setItem("templateAction", 'templateV2');
    }
  }, [])

  useEffect(() => {
  sessionStorage.removeItem("view");  
}, []);

  const fetchUserProfile = async () => {
    try {
      const response = await getProfile();
      const { access_projects } = response.data.user.data;
      if (
        access_projects.length &&
        access_projects.find((project) => project.project_id === projectId.pid)
      ) {
        setAccess(
          access_projects.find(
            (project) => project.project_id === projectId.pid
          )
        );
      } else {
        setAccess({ access: "All", project_id: "" });
      }
    } catch (err) {
    }
  };

  const fetchConvential = async () => {
    try {
      if (
        !conventionMode.isSuccess ||
        conventionMode.set_payload !== JSON.stringify({ project_id, tb_id })
      ) {
        dispatch(fetchConventionalMode(project_id, tb_id));
      } else if (
        conventionMode.isSuccess &&
        conventionMode.response.length > 0
      ) {
        const { response } = conventionMode;
        const unique = [];

        const duplicates = response.data.data.line_items.filter((o) => {
          if (unique.find((i) => i.ledger_code === o.ledger_code)) {
            return true;
          }
          unique.push(o);
          return false;
        });
        setDuplicateItems(duplicates);
        setTotalRow(response.data.data.line_items);
        setDeleteRow(false);
        setUpdateRows(false);
      }
    } catch (error) {
    }
  };

  // const fetchGroupData = async () => {
  //   if (
  //     !groupData.isSuccess ||
  //     groupData.set_payload !== JSON.stringify({ project_id, tb_id })
  //   ) {
  //     dispatch(fetchTTGroupData(project_id, tb_id));
  //   }
  // };

  function handleApplyFilter() {
    setRender(Math.random());

    if (filterData.length > 0) {
      filterData.map((filter, i) => {

        if (i === 0) {
          if (filter.column === "" && filter.change === "") {
            return;
          }
          if (
            filter.column !== "ledger_name" &&
            filter.column !== "ledger_code" &&
            filter.select === "Less than"
          ) {
            const res = tableData.filter((line) => {
              if (line[`${filter.column}`] < filter.startAmount) {
                return line;
              }
            });
            setTotalFilter(res);
            return;
          }

          if (
            filter.column !== "ledger_name" &&
            filter.column !== "ledger_code" &&
            filter.select === "Greater than"
          ) {
            const res = tableData.filter((line) => {
              if (line[`${filter.column}`] > Number(filter.startAmount)) {
                return line;
              }
            });
            setTotalFilter(res);
            return;
          }

          if (
            filter.column !== "ledger_name" &&
            filter.column !== "ledger_code" &&
            filter.select === "Equal to"
          ) {
            const res = tableData.filter((line) => {
              if (line[`${filter.column}`] === Number(filter.startAmount)) {
                return line;
              }
            });
            setTotalFilter(res);
            return;
          }

          const res = tableData.filter((line) => {
            if (
              line[`${filter.column}`]
                .toLowerCase()
                .includes(`${filter.change}`.toLowerCase())
            ) {
              return line;
            }
          });
          setTotalFilter(res);
          return;
        }
      });
    }
  }
  const handleFS = () => {
    history.push(`/preview`);
  };
  function handleDrop(e) {
    setConfirmDelete(!confirmDelete);
  }

  useEffect(() => {
    if (conventionMode && conventionMode.isSuccess) {
      fetchConvential();
    }
  }, [conventionMode.response]);

  useEffect(() => {
    const handleGroupingItemDeleted = () => {
      dispatch(fetchConventionalMode(project_id, tb_id, 1, conventionMode?.pagination?.limit || 100, conventionMode?.activeFilters, hideItems ? 'ungrouped' : undefined));
    };
    window.addEventListener('groupingItemDeleted', handleGroupingItemDeleted);
    return () => window.removeEventListener('groupingItemDeleted', handleGroupingItemDeleted);
  }, [hideItems, conventionMode]);

  useEffect(() => {
    setRender(Math.random());
  }, [grouping]);

  useEffect(() => {
    fetchMappingDetails();
  if (editTranslation) {
    fetchMappingDetails();
  }
}, [editTranslation]);

  useEffect(() => {
    handleApplyFilter();
    findProject();
    findWorkspace();
  }, [filterData]);

  const hiddenFileInput = React.useRef(null);

  const existFileInput = React.useRef(null);

  const handleChange = (e, type) => {
    e.preventDefault();
    setType(type);
    const fileListAsArray = e.target.files;
    if (
      (fileListAsArray[0].type === "application/vnd.ms-excel") |
      (fileListAsArray[0].type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
    ) {
      const auth = localStorage.getItem("auth_token");
      let headers = {
        "x-auth-token": auth,
        // "Content-Type": "multipart/form-data",
        "Content-Type": "application/json",
      };
      const project_id = localStorage.getItem("project_id");
      const data = new FormData();
      data.append("file", fileListAsArray[0]);

      axios
        .post(`/api/v1/uploads/upload-headers/${project_id}`, data, {
          headers,
        })
        .then((response) => {
          setHeaders(Object.keys(response.data.result.data[0].segregatedJson));
          setTempID(response.data.tmp_id);
          setAssignValues(true);
          uploadTb(false);
        })
        .catch((error) => {
        });
    }
  };

  const handleOpen = (type) => {
    uploadTb(false);
    history.push("/createproject/uploadtb");
  };

  let total_cy = 0;
  let total_adjusted = 0;
  let someData = "";
  if (tableData.length > 0) {
    someData = tableData;
    total_cy = someData.reduce((totalCy, i) => totalCy + Number(i.cy), 0);
    const total_py = someData.reduce((totalPy, i) => totalPy + Number(i.py), 0);
    total_adjusted = someData.reduce(
      (totalPy, i) => Number(totalPy) + Number(i.adjusted_amount),
      0
    );
    const total_amnt = total_cy - total_adjusted;
  }

  const calculateCY = () => {
    let total = 0;

    tableData.forEach((element) => {
      if (element.cy !== 0) {
        total = total + Number(element.cy);
      }
    });

    return total;
  };

  const calculatePY = () => {
    let total = 0;

    tableData.forEach((element) => {
      if (element.py !== 0) {
        total = total + Number(element.py);
      }
    });
    return total;
  };

  function handleSelect(type) {


    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal("Warning", 'You dont have any access to delete records', 'warning')
    } else {
      if (type === "Delete Record") {
        setDeleteItemsModal(true);
      }

      setConfirmDelete(false);
    }
  }

  const handleSubmit = () => {
    const data = {
      ledger_name: Name.ledgerName,
      ledger_code: Name.LedgerCode,
      branch: Name.branchName,
      py: Name.previousBalance,
      cy: Name.currentBalance,
    };

    axios
      .post(
        `/api/v1/tb-mapping/heading-classification/${project_id}/${tempID}`,
        data,
        { headers }
      )
      .then((response) => {
        if (type === "new") {
          const auth = localStorage.getItem("auth_token");
          let headers = {
            "x-auth-token": auth,
            // "Content-Type": "multipart/form-data",
            "Content-Type": "application/json",
          };
          const project_id = localStorage.getItem("project_id");
          axios
            .post(`/api/v1/uploads/existing-tb/${project_id}/${tempID}`, data, {
              headers,
            })
            .then((response) => {
              dispatch(fetchConventionalMode(project_id, tb_id));
              dispatch(fetchTTBSData(project_id, tb_id))
              dispatch(fetchTTPNLData(project_id, tb_id))

              setAssignValues(false);
              setUpdateRows(true);
              // setLoading(true);
            })
            .catch((error) => {
            });
        } else {
          // setData((Data) => [...Data, fileListAsArray]);
          // setConfirm((confirm) => [...confirm, false]);
          const auth = localStorage.getItem("auth_token");
          let headers = {
            "x-auth-token": auth,
            // "Content-Type": "multipart/form-data",
            "Content-Type": "application/json",
          };
          const project_id = localStorage.getItem("project_id");
          axios
            .post(`/api/v1/uploads/merge-tb/${project_id}/${tempID}`, data, {
              headers,
            })
            .then((response) => {
              // eliminateDupe(response.data.data.line_items);
              dispatch(fetchConventionalMode(project_id, tb_id));
              // dispatch({
              //   type: actionTypes.SET_TABLE_DATA,
              //   payload: response.data.data.line_items,
              // });
              setAssignValues(false);
              setUpdateRows(true);
            })
            .catch((error) => {
            });
        }
      })
      .catch((error) => {
      });
  };

  const findProject = async () => {
    const res = await getAllProjects();
    if (res.status === 200) {
      setAllProject(res.data.project_list);
    }
  };
  const findWorkspace = async () => {
    const res = await getAllWorkspace();
    if (res.status === 200) {
      setAllWorkspace(res.data.getWorkspace);
    }
  };


  const AccessProject = () => {
    const nameOfWs = allProject.filter((adj) => adj._id === project_id);
    const result = nameOfWs[0]?.workspace_id ? nameOfWs[0]?.workspace_id : "";
    const accessData = allWorkspace.filter((adj) => adj._id === result);
    const resultWorkspace = accessData[0]?.access_status
      ? accessData[0]?.access_status
      : "";
    return resultWorkspace;
  };
  const getLocalDateString = (dStr) => {
    // Convert to local date string for inputs
    const d = new Date(dStr);
    if (isNaN(d)) return "";
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };

  return (
    <>
      <ErrorPopup
        isOpen={errorData !== null}
        title={errorData?.title}
        message={errorData?.message}
        onClose={() => setErrorData(null)}
      />
      <SuccessPopup
        isOpen={showSuccessPopup}
        message={successMessage}
        onClose={() => {
          setShowSuccessPopup(false);
          setEditTranslation(false);
        }}
      />
    <div style={{ maxHeight: "100vh" }}>
      {shareScreen ? <ShareScreen SetShareScreen={SetShareScreen} /> : null}
      {addGrouping ? (
        <AddGrouping
          setOtherGrouping={setOtherGrouping}
          newSg={newSg}
          setAddGrouping={setAddGrouping}
          setRowData={setRowData}
          rowData={rowData}
        />
      ) : null}
      {addNoteGrp ? (
        <AddNoteGroup
          setAddNoteGrp={setAddNoteGrp}
          setRowData={setRowData}
          rowData={rowData}
        />
      ) : null}
      {populateFs ? <PopulateFs setPopulateFs={setPopulateFs} /> : null}
      {deletedMenu ? (
        <DeletedFile
          setDeleteMenu={setDeleteMenu}
          select={select}
          setUpdateRows={setUpdateRows}
        />
      ) : null}
      {addLedger ? (
        <AddLedger close={setAddLedger} name="Create a new Ledger Item" />
      ) : null}
      {showSwitchMode ? (
        <SwitchMode
          close={setSwitchMode}
          name="Choose a Mapping Mode"
          currentMode="2"
        />
      ) : null}
      {expandLedger ? (
        <ExpandLedger
          close={setExpandLedger}
          name="Ledger Detail"
          select={select}
        />
      ) : null}
      {addLedgerAbove ? (
        <AddLedger
          close={setAddLedgerAbove}
          name="Add Ledger Above"
          select={select}
        />
      ) : null}
      {addLedgerBelow ? (
        <AddLedger
          close={setAddLedgerBelow}
          name="Add Ledger Below"
          select={select}
        />
      ) : null}
      {confirmation ? (
        <Confirmation
          setConfirmation={setConfirmation}
          confirmationMenu={confirmationMenu}
          select={select}
        />
      ) : null}

      {showAssignValues ? (
        <AssignValuesData
          show={showAssignValues}
          setShow={setAssignValues}
          info={info}
          index={index}
          setName={setName}
          Name={Name}
          handleSubmit={handleSubmit}
          headers={headerdata}
        />
      ) : null}
      {/* </div><div className={commoncss.pageLayout}> */}
       <div className={commoncss.pageLayout}> 
        <Sidebar />
        <style>{`
          .template_content_wrapper .bk-closure-tb-header {
            padding-left: 8px !important;
            padding-right: 8px !important;
          }
          .template_content_wrapper .tabsinside > div {
            padding-left: 8px !important;
            padding-right: 8px !important;
          }
        `}</style>
        {showDeletedItems ? (
          <div className={`${commoncss.pageContent}`} style={{ flex: 1 }}>
            <DeletedItemsPage onClose={() => setShowDeletedItems(false)} />
          </div>
        ) : (
        <div className={`d-flex ${commoncss.pageContent} template_content_wrapper`}>
          <div
            className={`${commoncss.w100} `}
            style={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}
          >
            <div className="bk-closure-tb-header" style={{ gap: "100px", flexShrink: 0 }}>
              <div className="bk-closure-tb-header-left mr-0">
                <LeftIcon
                  height={15}
                  width={15}
                  className="clickable mr-2"
                  onClick={() => history.push(`/financialstatement/${ws_id}`)}
                />
                <FilterIcon
                  className={commoncss.clickable}
                  onClick={() => {
                    setFilterShow(!filterShow);
                  }}
                />

                {multiSelectedRows.length < 1 ? (
                  <DeleteIcon
                    className={commoncss.clickable}
                  />
                ) : (
                  <DeleteIcon
                    className={commoncss.clickable}
                    onClick={() => {
                      handleSelect("Delete Record");
                    }}
                  />
                )}
                <span className="ml-1"
                  onClick={() => {
                    history.push("/adjustments");
                  }}><div className="toggle-container "><EditIcon
                    className={commoncss.clickable}
                    style={{ "marginTop": "3px" }}
                    width={20}
                  /><span className={`toggle-label ml-1  ${commoncss.fs14} ${commoncss.clrGreen}`}>Adjustments</span></div>
                </span>

             <div className="ml-1 d-flex align-items-center">
                <span className="d-inline-flex align-items-center">
                  <ToggleButton
                    label="Split mapping"
                    labelclass_="ml-1"
                    checked={checkYearly}
                    disabled={user.responsibilities === "approver" || user.responsibilities === "view"}
                    onToggle={(val) => dispatch(toggleCheckYearly(val))}
                  />
                </span>

                <span className="ml-2 d-inline-flex align-items-center">
                  <input
                    type="checkbox"
                    checked={hideItems}
                    onChange={(e) => {
                      SetHideItems(e.target.checked);
                      dispatch(fetchConventionalMode(project_id, tb_id, 1, conventionMode?.pagination?.limit || 100, conventionMode?.activeFilters, e.target.checked ? 'ungrouped' : undefined));
                    }}
                    style={{ verticalAlign: "middle" }}
                  />
                  <span
                    className="ml-1"
                    style={{
                      fontSize: "13px",    
                      fontWeight: 400,
                      lineHeight: "1",
                      color: "var(--primary-color)",
                      marginTop: "1px",
                    }}
                  >
                    Hide Grouped Items
                  </span>
                </span>
             </div>
              </div>
              <div className="button-group">
                <button
                  className={`${buttoncss.custom_btn} ${buttoncss.primary}`}
                  style={{
                    borderRadius: "8.18px 0px 0px 8.18px",
                    height: "33px",
                  }}
                >
                  Template mode
                </button>
                <button
                  className={`${buttoncss.custom_btn} ${buttoncss.secondary}`}
                  style={{
                    borderRadius: "0 8.18px 8.18px 0",
                    background: "#f5f5f5",
                    height: "33px",
                  }}
                  onClick={() => {
                    sessionStorage.removeItem("view");
                    history.push(`/Conventional/${projectId.pid}`);
                  }}
                >
                  Conventional mode
                </button>
              </div>
              <div className="bk-closure-tb-header-right">
                {AccessProject() === "view" ? (
                  <RecycleBinIcon className={`${commoncss.clickable} mr-1`} width={22} height={25} style={{ "placeSelf": "center" }} />
                ) : (
                  <RecycleBinIcon
                    className={`${commoncss.clickable} mr-1`}
                    onClick={() => {
                      setShowDeletedItems(true);
                    }} width={22} height={25} style={{ "placeSelf": "center" }} />
                )}
                {hasTranslatedFS && (
                  <Button
                  btnColor={buttoncss.secondary}
                  class_={buttoncss.greyBg}
                  label={
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <EditIcon width={15} height={15}  />
                      Edit Translation
                    </span>
                  }
                  onClick={() => setEditTranslation(true)}
                  />
                )}
                {editTranslation && (

                  <div className={editcss.modalOverlay}>
                <div className={editcss.modalContainer}>

                  <div className={editcss.modalHeader} style={{ padding: "12px 24px" }}>
                    <span className={editcss.modalTitle}>Edit Translation</span>

                    <CloseIcon
                      className="clickable"
                      width={18}
                      height={18}
                      onClick={() => setEditTranslation(false)}
                    />
                  </div>
                  <div className={editcss.modalBody} style={{ padding: "10px 22px", gap: "12px 20px" }}>
                   <div className={editcss.field}>
                    <label>Select Preset</label>
                    <input
                      className={editcss.inputField}
                      placeholder="Preset Name Here"
                    />
                  </div>

                   <div className={editcss.field}>
                   <label>Reporting Currency</label>

                <div className={editcss.dropdownWrapper}>
                  <div className={editcss.inputWrapper}>
                    <input
                      className={editcss.inputField}
                      placeholder="Select Currency"
                      readOnly
                      value={translationData.reportingCurrency}
                      onClick={() => setOpenCurrency(!openCurrency)}
                    />

                    <DropdownIcon className={editcss.dropdownIcon} />
                  </div>

                  {openCurrency && (
                    <div className={editcss.dropdownMenu}>
                      <div
                        className={editcss.dropdownOption}
                        onClick={() => handleSelectCurrency("INR")}
                      >
                        INR
                      </div>

                      <div
                        className={editcss.dropdownOption}
                        onClick={() => handleSelectCurrency("USD")}
                      >
                        USD
                      </div>

                      <div
                        className={editcss.dropdownOption}
                        onClick={() => handleSelectCurrency("CAD")}
                      >
                        CAD
                      </div>

                      <div
                        className={editcss.dropdownOption}
                        onClick={() => handleSelectCurrency("GBP")}
                      >
                        GBP
                      </div>

                      <div
                        className={editcss.dropdownOption}
                        onClick={() => handleSelectCurrency("EUR")}
                      >
                        EUR
                      </div>

                      <div
                        className={editcss.dropdownOption}
                        onClick={() => handleSelectCurrency("CHF")}
                      >
                        CHF
                      </div>
                    </div>
                  )}
                </div>
              </div>

                    <div className={editcss.field}>
                      <label>Company</label>
                      <input className={editcss.inputField} placeholder="Enter company name" />
                    </div>

                    <div className={editcss.field}>
                      <label>Nature Of Company</label>
                      <input className={editcss.inputField} placeholder="Enter nature of company" />
                    </div>

                    <div className={editcss.field}>
                      <label>Name Of The Financials</label>
                      <input className={editcss.inputField} placeholder="Financial statement Name" />
                    </div>

                    <div className={editcss.field}>
                      <label>Select The GAAP</label>
                      <input className={editcss.inputField} placeholder="Enter GAAP" icon={<DropdownIcon />} />
                    </div>

                   <div className={editcss.field}>
                    <label>Current Financial Year</label>
                    <div className={editcss.inputWrapper}>
                      <input className={editcss.inputField}  value={
                        currentFinancialYear
                          ? getLocalDateString(currentFinancialYear)
                          : ""
                      } placeholder="DD-MM-YYYY" icon={<DropdownIcon />} />

                      <CalendarIcon className={editcss.calendarIcon} />
                    </div>
                  </div>

                    <div className={editcss.field}>
                      <label>Previous Financial Year</label>

                      <div className={editcss.inputWrapper}>
                       <input className={editcss.inputField}
                        value={
                            previousFinancialYear
                              ? getLocalDateString(previousFinancialYear)
                              : ""
                          } placeholder="DD-MM-YYYY" icon={<DropdownIcon />} />

                      <CalendarIcon className={editcss.calendarIcon} />
                    </div>
                    </div>

                    <div className={editcss.field}>
                      <label>Select Presets/Chart Of Accounts</label>
                       <input className={editcss.inputField} placeholder="Select Presets/COA" icon={<DropdownIcon />} />
                    </div>

                    <div className={editcss.field}>
                      <label>Functional Currency</label>
                      <input className={editcss.inputField} 
                       value={functionalCurrency} placeholder="Functional Currency" icon={<DropdownIcon />} />
                    </div>

                    <div className={editcss.field} style={{ gridColumn: "span 2" }}>
                      <label>Select Investment Register</label>
                      <Dropdown
                        options={allInvestmentRegisters}
                        onSelect={(sel) => setInvestmentRegister(sel)}
                        placeHolder="Select Investment Register"
                        selected={investmentRegister}
                        searchable={true}
                      />
                    </div>

                  </div>

                  <div>
                    <div className={editcss.translationSection} style={{ padding: "4px 22px" }}>
                      <span className={editcss.translationTitle}>
                        Translation information : <b style={{ color: "#2D8861" }}>USD to INR</b>
                      </span>

                      <div className={editcss.translationContainer} style={{ marginTop: "4px", padding: "4px 16px" }}>
                        <table className={editcss.translationTable}>
                          <thead>
                            <tr>
                              <th>DATE</th>
                              <th>OPENING RATE</th>
                              <th>CLOSING RATE</th>
                              <th>AVERAGE RATE</th>
                            </tr>
                          </thead>

                         <tbody>
                          <tr>
                          <td>Current Year</td>

                          <td>
                          <input
                          type="number"
                          name="currentYearOpeningRate"
                          value={translationData.currentYearOpeningRate}
                          onChange={handleTranslationChange}
                          />
                          </td>

                          <td>
                          <input
                          type="number"
                          name="currentYearClosingRate"
                          value={translationData.currentYearClosingRate}
                          onChange={handleTranslationChange}
                          />
                          </td>

                          <td>
                          <input
                          type="number"
                          name="currentYearAverageRate"
                          value={translationData.currentYearAverageRate}
                          onChange={handleTranslationChange}
                          />
                          </td>
                          </tr>

                          <tr>
                          <td>Previous Year</td>

                          <td>
                          <input
                          type="number"
                          name="previousYearOpeningRate"
                          value={translationData.previousYearOpeningRate}
                          onChange={handleTranslationChange}
                          />
                          </td>

                          <td>
                          <input
                          type="number"
                          name="previousYearClosingRate"
                          value={translationData.previousYearClosingRate}
                          onChange={handleTranslationChange}
                          />
                          </td>

                          <td>
                          <input
                          type="number"
                          name="previousYearAverageRate"
                          value={translationData.previousYearAverageRate}
                          onChange={handleTranslationChange}
                          />
                          </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>

                  <div className={editcss.modalFooter} style={{ padding: "10px 22px" }}>
                   <Button
                      btnColor={buttoncss.primary}
                      label="Save Changes"
                      onClick={handleSaveTranslation}
                    />
                  </div>

                </div>
                  </div>
                )}

                <Button
                  btnColor={buttoncss.secondary}
                  class_={buttoncss.greyBg}
                  label="Upload TB"
                  onClick={() => user.responsibilities === "approver" || user.responsibilities === "view" ? null : uploadTb(true)}
                />
              {hasTranslatedFS && (
                <Button
                  btnColor={buttoncss.secondary}
                  class_={buttoncss.greyBg}
                  label={
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <ExportIcon width={15} height={15} />
                      Export
                    </span>
                  }
                  onClick={handleExportTranslation}
                />
              )}
                <Button
                  btnColor={buttoncss.primary}
                  label="Populate FS"
                  onClick={() => setPopulateFs(true)}
                />
              </div>
            </div>
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}
            >
              {loading && (
                <div
                  style={{
                    height: "80vh",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spinner animation="grow" size="sm" />
                  <Spinner animation="grow" style={{ margin: "1rem" }} />
                  <Spinner animation="grow" size="sm" />
                </div>
              )}
              <div
                className="tabsinside"
                style={{ width: "100%", flex: 1, overflow: "hidden", display: "flex", paddingBottom: "15px" }}
              >
                <SplitPane
                  minSizes={[500, 600]}
                  initialSizes={[50, 50]}
                  split="vertical"
                  collapseOptions={{
                    beforeToggleButton: <Button>⬅</Button>,
                    afterToggleButton: <Button>➡</Button>,
                    overlayCss: { backgroundColor: "black" },
                    buttonTransition: "zoom",
                    buttonPositionOffset: -20,
                    collapsedSize: 50,
                    collapseTransitionTimeout: 350,
                  }}
                  resizerOptions={{
                    css: {
                      width: "1px",
                      background: "transparent"
                    },
                    hoverCss: {
                      width: "5px",
                      background: "4px solid rgba(0, 0, 0)",
                    },
                    grabberSize: "5px",
                  }}
                >
                  <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    <div style={{ flex: 1, border: "1px solid #ddd", borderRadius: "15px", backgroundColor: "#fff", overflow: "hidden" }}>
                      <div id="TemplateScroll" style={{ height: "100%", overflow: "hidden", position: "relative" }}>
                        <div className="inner_table_zoom" style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                          {!loading && (
                            <BasicTable
                              template={true}
                              SetNewSg={SetNewSg}
                              setAddGrouping={setAddGrouping}
                              totalFilter={totalFilter}
                              hideItems={hideItems}
                              setTotalRow={setTotalRow}
                              tableData={someData}
                              hiddenFilter={hiddenFilter}
                              fetchConvential={setUpdateRows}
                              setRowData={setRowData}
                              rowData={rowData}
                              setUpdateTabs={setUpdateTabs}
                              getdata={getDataCount}
                              filterEnable={filterEnable}
                              isTempMode={true}
                              onRowRefsReady={(refs) => { tableRowRefs.current = refs.current; }}

                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ overflow: "hidden", height: "100%", display: "flex", flexDirection: "column" }}>
                    <div
                      style={{ height: "100%", display: "flex", flexDirection: "column" }}
                      onDragEnter={() => {
                        // setHighlighted('#e9ebf0')
                      }}
                      onDragLeave={() => {
                        // setHighlighted('')
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <TemplateTabs
                        SetNewSg={SetNewSg}
                        setAddGrouping={setAddGrouping}
                        updateTabs={updateTabs}
                        setUpdateTabs={setUpdateTabs}
                        setAddNoteGrp={setAddNoteGrp}
                        onNoteSelect={handleNoteSelect}
                        hideItems={hideItems}
                        onAfterDrop={() => {
                          if (hideItems) {
                            dispatch(fetchConventionalMode(project_id, tb_id, 1, conventionMode?.pagination?.limit || 100, conventionMode?.activeFilters, 'ungrouped'));
                          }
                        }}
                      />
                    </div>
                  </div>
                </SplitPane>
              </div>
              {deleteItemsModel && (<Modal
                headerActions={
                  <CloseIcon
                    onClick={() => {
                      // handleClose();
                      setDeleteItemsModal(false);
                    }}
                    className="clickable"
                  />
                }
                headerBottomLine={false}
                onClose={() => console.log("Modal Closed")}
              >
                <span className={`${modalcss.modalBodyHead} mb-1`}>
                  Do you want to <span className="fw700">delete </span>
                  selected items?
                </span>
                <span
                  className={`${modalcss.modalBodycnt}`}
                  style={{ "marginBottom": "35px" }}
                >
                  Once deleted, the item can be restored from the Bin.
                </span>
                <span
                  className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
                >
                  <Button
                    btnColor={buttoncss.danger}
                    label="Delete"
                    icon={<DeleteIconWhite width={20} height={20} />}
                    onClick={() => {
                      // deleteCompany();
                      let deletedData = {
                        row: multiSelectedRows,
                      };
                      deleteConventionalLineItems(project_id, deletedData)
                        .then((res) => {
                          dispatch(fetchConventionalMode(project_id, tb_id));
                          dispatch(deleteLineItems(multiSelectedRows, project_id, tb_id));
                          setSuccessMessage("Deleted successfully");
                          setShowSuccessPopup(true);
                          setTimeout(() => {
                            setShowSuccessPopup(false);
                          }, 1000);
                        })
                        .catch((err) => {
                          swal("somthing went wrong", {
                            icon: "danger",
                          });
                        });
                      setDeleteItemsModal(false);
                    }}

                  />
                  <Button
                    btnColor={buttoncss.secondary_del}
                    label="Cancel"
                    onClick={() => {
                      // handleClose();
                      setDeleteItemsModal(false);
                    }}
                  />
                </span>
              </Modal>
              )}
            </motion.div>
          </div>
        </div>
        )}

        <Filter
          show={filterShow}
          handleApplyFilter={handleApplyFilter}
          setFilterShow={setFilterShow}
          setObject={setObject}
          setFilterRow={setFilterRow}
          filterRow={filterRow}
          SetConfirmFilClose={SetConfirmFilClose}
          filterEnable={filterEnable}
          filterHandler={setFilterEnable}
          hideItems={hideItems}
        />
        {confirmDelete ? (
          <DeleteSelected
            setDeleteRow={setDeleteRow}
            fetchConvential={fetchConvential}
            setConfirmDelete={setConfirmDelete}
            select={select}
            setConfirmation={setConfirmation}
            setConfirmationMenu={setConfirmationMenu}
            setExpandLedger={setExpandLedger}
            setAddLedgerBelow={setAddLedgerBelow}
            setAddLedgerAbove={setAddLedgerAbove}
          />
        ) : null}
      </div>

      {openDuplicateModal && (
        <DeleteDuplicate
          CMResponse={response}
          duplicateItems={duplicateItems}
          openDuplicateModal={openDuplicateModal}
          setDuplicateModal={setDuplicateModal}
          fetchConvential={setUpdateRows}
        />
      )}

      {tb_upload && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
     <div
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "16px",
        width: "600px",
        height: "380px",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "24px",
        fontFamily: "'DM Sans', sans-serif"
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="d-flex justify-content-between align-items-center pb-3 mb-2" style={{ borderBottom: "1px solid #EAEAEA", margin: "0 -24px", padding: "0 24px" }}>
        <h5 style={{ margin: 0, fontSize: "20px", color: "#183930", fontFamily: "'DM Sans', sans-serif" }}>Upload Trial Balance (Excel)</h5>
        <span style={{ cursor: "pointer", fontSize: "16px", color: "#777" }} onClick={() => uploadTb(false)}>✕</span>
      </div>

      <div className="d-flex justify-content-between" style={{ marginBottom: "10px", gap: "16px", flexGrow: 1 }}>

        <div
          style={{
            width: "90%",
            border: "1px solid #C2E6D1",
            borderRadius: "16px",
            cursor: "pointer",
            overflow: "hidden",
            marginTop: "15px",
            display: "flex",
            flexDirection: "column",
            fontFamily: "'DM Sans', sans-serif"
          }}
          onClick={() => handleOpen("existing")}
        >
          <div style={{ height: "180px", background: "#ffffff", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <img src={MultipleFiles} alt="Existing TB" style={{ maxHeight: "90%", maxWidth: "90%", objectFit: "contain" }} />
          </div>
          <div style={{ padding: "10px 14px", background: "#f4faf5", textAlign: "left", flexGrow: 1 }}>
            <div style={{ fontSize: "18px", color: "#183930", marginBottom: "4px", fontWeight: 500 }}>
              Existing TB Upload
            </div>
            <div style={{ fontSize: "14px", color: "#809790", lineHeight: "1.4" }}>
              Make sure only one sheet is present if one file is uploaded at a time
            </div>
          </div>
        </div>

        <div
          style={{
            width: "90%",
            border: "1px solid #C2E6D1",
            borderRadius: "16px",
            cursor: "pointer",
            overflow: "hidden",
            marginTop: "15px",
            display: "flex",
            flexDirection: "column",
            fontFamily: "'DM Sans', sans-serif"
          }}
          onClick={() => handleOpen("new")}
        >
          <div style={{ height: "180px", background: "#ffffff", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <img src={MultipleSheets} alt="New TB" style={{ maxHeight: "90%", maxWidth: "90%", objectFit: "contain" }} />
          </div>
          <div style={{ padding: "10px 14px", background: "#f4faf5", textAlign: "left", flexGrow: 1 }}>
            <div style={{ fontSize: "18px", color: "#183930", marginBottom: "4px", fontWeight: 500 }}>
              New TB Upload
            </div>
            <div style={{ fontSize: "14px", color: "#809790", lineHeight: "1.4" }}>
              Make sure only one sheet is present if one file is uploaded at a time
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
)}
    </div>
    </>
  );
};
export default NewTemplate;
